import { ShipmentListFiltersModel } from '@src/models';
import { createContext } from 'react';

type AdditionalActionsContext = {
  handleFiltersApply: (selectedFilters: ShipmentListFiltersModel, _?: boolean) => void;
  clearFilters: () => void;
};

export const additionalActionsContext = createContext<AdditionalActionsContext | null>(null);
